import * as React from "react";
//import { experimentalStyled as styled } from '@mui/material/styles';
import { Button, Flex } from "@aws-amplify/ui-react";
import { Checkbox, Dialog, FormControl, Grid, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { getOverrideProps } from "../ui-components/utils";
import { DynamoDBClient, ScanCommand } from '@aws-sdk/client-dynamodb';
import { TextField } from "@aws-amplify/ui-react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
    API_Authenticate,
    API_GetAPIVersion,
    Settings,
} from "../services/GetInvoiceData";
import { useIsMobile } from "helpers/CustomHooks";
import { SelectAllTenants } from "services/GraphQlHelper";
import config from "../amplifyconfiguration.json";

const akid = config.aws_image_bucket_access_key;
const sak = config.aws_image_bucket_secret_key;

interface UpdateClientProps {
    onSuccess: () => void;
    onCancel: () => void;
}

export default function TenantStatus(props: UpdateClientProps) {
    //const [selectedPage, setSelectedPage] = React.useState("default");
    const [settings, setSettings] = React.useState([] as Settings[]);
    const [addRelationOpen, setAddRelationOpen] = React.useState(false);
    const [setting, setSetting] = React.useState({} as Settings);
    const [fileDialogOpen, setFileDialogOpen] = React.useState(false);
    const [templateDialogOpen, setTemplateDialogOpen] = React.useState(false);
    const [saveURL, setSaveURL] = React.useState(false);
    const isMobile = useIsMobile();
    const [tenants, setTenants] = React.useState([] as any[]);
    const [showTenantHistory, setShowTenantHistory] = React.useState(false);

    function UsersTable() {
        console.log("Calling UsersTable");
        return (
            <>
                <TableContainer component={Paper}>
                    <Table aria-label='simple table'>
                        <TableHead>
                            <TableRow>
                                {!isMobile && (
                                    <TableCell align='left'>
                                        <h5>Tenant Name</h5>
                                    </TableCell>
                                )}
                                <TableCell align='left'>
                                    <h5>Subdomain</h5>
                                </TableCell>
                                <TableCell align='left'>
                                    <h5>API Version</h5>
                                </TableCell>
                                {showTenantHistory &&
                                    <TableCell align='left'>
                                        <h5>Ping Date</h5>
                                    </TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tenants &&
                                tenants
                                    .sort((a, b) => (a.pingdate < b.pingdate ? 1 : -1))
                                    .map((row, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                "&:last-child td, &:last-child th": { border: 0 },
                                            }}
                                        >
                                            {!isMobile && (
                                                <TableCell
                                                    key={"11-" + index}
                                                    component='th'
                                                    scope='row'
                                                >
                                                    {row.name}
                                                </TableCell>
                                            )}
                                            <TableCell
                                                key={"1-" + index}
                                                component='th'
                                                scope='row'
                                            >
                                                {row.tenantid}
                                            </TableCell>
                                            <TableCell
                                                key={"2-" + index}
                                                component='th'
                                                scope='row'
                                            >
                                                {row.version}
                                            </TableCell>
                                            {showTenantHistory &&
                                                <TableCell
                                                    key={"4-" + index}
                                                    component='th'
                                                    scope='row'
                                                >
                                                    {row.pingdate}
                                                </TableCell>}
                                        </TableRow>
                                    ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        );
    }

    async function getTenantStatus(url: string) {
        var token = await API_Authenticate();
        var data = await API_GetAPIVersion(url, token);
        console.log("Got Version: ", data);
        if (data)
            return data.Version;
        else
            return "Error";
    }

    React.useEffect(() => {
        getTenants();
    }, []);

    React.useEffect(() => {
        if (showTenantHistory)
            getTenantHistory();
        else
            getTenants();
    }, [showTenantHistory]);

    async function getTenants() {
        let tnts = new Array();
        console.log("Selecting tenants...");

        var allTnts = await SelectAllTenants();
        if (allTnts && allTnts.data?.listTenants?.items) {
            for (let i = 0; i < allTnts.data.listTenants.items.length; i++) {
                const version = await getTenantStatus(allTnts.data.listTenants.items[i].url);
                if (version) {
                    var tdata = {
                        version: version,
                        name: allTnts.data.listTenants.items[i].name,
                        tenantid: allTnts.data.listTenants.items[i].subdomain,
                        pingdate: null
                    };
                    tnts.push(tdata);
                }
            }
            console.log("Tenants: ", tnts);
            setTenants(tnts);
        }

        /*SelectAllTenants().then((tenants: any) => {
            console.log("Got tenants...", tenants);
            if (tenants?.data?.listTenants?.items)
                for (let i = 0; i < tenants.data.listTenants.items.length; i++) {
                    getTenantStatus(tenants.data.listTenants.items[i].url).then(version => {
                        var tdata = {
                            version: version,
                            name: tenants.data.listTenants.items[i].name,
                            tenantid: tenants.data.listTenants.items[i].subdomain
                        };
                        tnts.push(tdata);
                        setTenants(tnts);
                    }
                    );
                }
        });*/
    }

    async function getTenantHistory() {
        const config = { region: "us-east-1", credentials: { accessKeyId: akid, secretAccessKey: sak } };
        const docClient = new DynamoDBClient(config);
        const input = { TableName: "PingLog" }
        let tenantHist = [];
        const command = new ScanCommand(input);

        const dbResp = await docClient.send(command);

        if (dbResp) {
            const items = dbResp.Items;

            if (!items)
                return;

            for (const x of items) {
                console.log("History: ", x);
                var createTime = x.createdAt.S;
                console.log("History created: ", createTime);
                if (!createTime)
                    createTime = "";

                if (x.subdomain) {
                    var tdata = {
                        version: x.response.S,
                        name: x.subdomain.S,
                        tenantid: x.subdomain.S,
                        pingdate: createTime
                    };
                    tenantHist.push(tdata);
                }
            }
            setTenants(tenantHist);
        }
    }

    function showPage() {
        return (
            <>
                <UsersTable />
                <br />
                <br />
                <br />
                <Button
                    children='Go Back'
                    type='reset'
                    onClick={(event) => {
                        event.preventDefault();
                        props.onSuccess();
                    }}
                    {...getOverrideProps(null, "ClearButton")}
                ></Button>
            </>
        );

    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Stack direction={"row"}>
                <Checkbox
                    checked={showTenantHistory}
                    onChange={(
                        e: any,
                    ) =>
                        setShowTenantHistory(
                            e.target.checked,
                        )
                    }
                />
                <Typography marginTop={"9px"}>
                    Show History
                </Typography>

            </Stack>
            {showPage()}
        </Box>
    );
}
